import { t } from './i18n';
import { getUserAccountType, getUserAccountStatus, getUserAccountInactiveReason } from './userBanActions';
export const SUSPENSION_DAYS = [1, 3, 7, 30, 90];
export function canManageSuspension(user, environment) {
  const type = getUserAccountType(user);
  return type === 'USER' || (environment === 'test' && type === 'TESTER');
}
export function canApplySuspension(user) {
  return Number(getUserAccountStatus(user)) === 1 || Number(getUserAccountInactiveReason(user)) === 4;
}
export function isSuspended(user) { return Number(getUserAccountStatus(user)) === 0 && Number(getUserAccountInactiveReason(user)) === 4; }

export const SUSPENSION_CATEGORIES = ["spam_advertising", "harassment_threats", "hate_discrimination", "inappropriate_content", "impersonation_fraud", "privacy_violation", "service_abuse", "other"];
export function suspensionPublicReason(dialog) {
  if (dialog.action === 'lift' || dialog.category === 'other') return dialog.reason.trim();
  return SUSPENSION_CATEGORIES.includes(dialog.category) ? t(`user.suspension.reasons.${dialog.category}`) : '';
}
export function isSuspensionFormValid(dialog) {
  const reason = suspensionPublicReason(dialog);
  return Boolean(reason && reason.length <= 500 && dialog.notes.trim().length <= 2000 &&
    (dialog.action === 'lift' || (SUSPENSION_CATEGORIES.includes(dialog.category) &&
      SUSPENSION_DAYS.includes(Number(dialog.days)) && (dialog.category !== 'other' || dialog.notes.trim()))));
}
